import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { range } from 'lodash';

import Search from './ProjectsViewSearch';
import Pagination from '../../../shared/Pagination';

import { pageUpdateAction, getChartsAction, updateProjectAction } from '../actions/projectsPage.js';

const ProjectsView = (props) => {
  const dispatch = useDispatch();
  const chartsPage = useSelector((state) => state.chartsPage);
  const { team } = useSelector((state) => state.profile);

  const viewChartsPerm = true;

  useEffect(() => {
    if (team.id) {
      dispatch(getChartsAction());
    }
  }, [team.id]);

  // todo: this should be moved to middleware
  useEffect(() => {
    dispatch(getChartsAction());
  }, [chartsPage.page, props.deleted, viewChartsPerm]);

  const updateProject = (project, updatedProps) => {
    dispatch(updateProjectAction({ project, updatedProps }));
  };

  const noResults = chartsPage.charts.length === 0;
  const emptyQuery = chartsPage.query === '';
  const isFeedbackFormActive = chartsPage.isFeedbackFormActive;

  return (
    <div className="projects-view">
      <Search
        simple={props.simple}
        deleted={props.deleted}
        viewChartsPerm={viewChartsPerm}
        checkPermission={() => true}
      />

      {
        // No results
        !emptyQuery && noResults && (
          <div className="flex items-center justify-center h-52">
            <p className="text-2xl text-center text-ev-navy-blue">
              <div className="mb-4">
                Sorry, no results for
                <span className="font-bold"> “{chartsPage.query}” </span>
              </div>
            </p>
          </div>
        )
      }

      {!noResults && (
        <div className="project-grid mb-12 mt-4">
          {
            // Search is ongoing
            chartsPage.charts.includes(null) && range(chartsPage.pageSize).map(props.placeholder)
          }

          {
            // Search got results
            !chartsPage.charts.includes(null) &&
              chartsPage.charts.length > 0 &&
              chartsPage.charts.map((chart, i) => (
                <props.with
                  key={chart.id}
                  chart={chart}
                  highlighted={!i && isFeedbackFormActive}
                  deleted={props.deleted}
                  team={props.team}
                  checkPlanPermission={{ ...props.checkPlanPermission }}
                  updateProject={updateProject}
                />
              ))
          }
        </div>
      )}

      {chartsPage.pageCount > 1 && (
        <Pagination
          pageCount={chartsPage.pageCount}
          currentPage={chartsPage.page}
          onSelectPage={(p) => {
            dispatch(pageUpdateAction({ page: p }));
          }}
        />
      )}
    </div>
  );
};

export default ProjectsView;
